export default [
  {
    path: '/404',
    name: 'notFound',
    component: () => import('@/views/error/NotFound.vue')
  },
  {
    path: '/500',
    name: 'serverError',
    component: () => import('@/views/error/ServerError.vue')
  },
  // Always leave this as last one
  {
    path: '*',
    redirect: '/404'
  }
];
